import { render, staticRenderFns } from "./OptionEditBudgetsTab.vue?vue&type=template&id=c304b1b4"
import script from "./OptionEditBudgetsTab.vue?vue&type=script&lang=ts"
export * from "./OptionEditBudgetsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports